export default "__VITE_ASSET__DpXqX5gw__"